const data_pre_activity = [
  {
    name: 'mangrove_scooping_visits',
    icon: 'focus-3-line',
    key: 'mangrove-scooping-visits'
  },
  {
    name: 'mangrove_rras',
    icon: 'crosshair-line',
    key: 'mangrove-rras'
  },
  {
    name: 'mangrove_pras',
    icon: 'crosshair-2-line',
    key: 'mangrove-pras'
  },
  {
    name: 'mangrove_program_socializations',
    icon: 'projector-line',
    key: 'mangrove-program-socializations'
  },
  {
    name: 'mangrove_organization_groups',
    icon: 'user-community-line',
    key: 'mangrove-organization-groups'
  },
]
const data_collecting = [
  {
    name: 'mangrove',
    icon: 'database-2-line',
  },
]
const data_activity = [
  {
    name: 'mangrove_planting_socialization',
    icon: 'projector-2-line',
  },
  {
    name: 'mangrove_planting_hole',
    icon: 'flower-line',
  },
]

const module = {
  config: {
    name: "mangrove-data",
    icon: 'drop',
    desc: "Data utama untuk pengelolaan Pendataan Mangrove",
    layout: true,
    order: 2
  },
  routes: [
    {
      name: 'pre-activity-mangrove',
      type: 'parent',
      // icon: "user",
      redirectName: 'mangrove_scooping_visits',
      child: [
        ...data_pre_activity.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./mangrove-pre-activities/${v.key}/${v.key}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'pendataan-mangrove',
      type: 'parent',
      // icon: "user",
      redirectName: 'mangrove',
      child: [
        ...data_collecting.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./mangrove-data-collecting/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'mangrove-activity',
      type: 'parent',
      // icon: "user",
      redirectName: 'mangrove_planting_socialization',
      child: [
        ...data_activity.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: "",
            separator: null
          }
        }),
      ]
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/mangrove/_index.js